import { c as _c } from "react/compiler-runtime";
import type { MutableRefObject } from 'react';
import { createRef, useCallback, useEffect, useMemo, useState } from 'react';
const usePinInputRefs = pinInputCount => {
  const $ = _c(15);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [refs, setRefs] = useState(t0);
  let t1;
  if ($[1] !== refs) {
    t1 = referenceIndex => refs[referenceIndex - 1]?.current;
    $[1] = refs;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const previous = t1;
  let t2;
  if ($[3] !== refs) {
    t2 = referenceIndex_0 => refs[referenceIndex_0 + 1]?.current;
    $[3] = refs;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const next = t2;
  let t3;
  if ($[5] !== refs) {
    t3 = referenceIndex_1 => refs[referenceIndex_1]?.current;
    $[5] = refs;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const get = t3;
  let t4;
  let t5;
  if ($[7] !== pinInputCount) {
    t4 = () => {
      setRefs(elRefs => Array(pinInputCount).fill("").map((_, i) => elRefs[i] || createRef()));
    };
    t5 = [pinInputCount];
    $[7] = pinInputCount;
    $[8] = t4;
    $[9] = t5;
  } else {
    t4 = $[8];
    t5 = $[9];
  }
  useEffect(t4, t5);
  let t6;
  if ($[10] !== get || $[11] !== next || $[12] !== previous || $[13] !== refs) {
    t6 = {
      refs,
      previous,
      next,
      get
    };
    $[10] = get;
    $[11] = next;
    $[12] = previous;
    $[13] = refs;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default usePinInputRefs;